import api from '../index'

/**
 * @param {object} data 传参
 * @description 帐号密码登录接口
 * @returns {Promise} 请求结果
 */
export function reqLogin(data: any) {
  return api.post('/common/login/login', data)
}
/**
 * @description 帐号密码图形验证码登录接口
 * @returns {Promise} 请求结果
 */
export function reqLoginImgCode() {
  return api.post('/common/login/captcha', {})
}
/**
 * @param {object} data 传参
 * @description 邮箱登录接口
 * @returns {Promise} 请求结果
 */
export function reqLoginEmail(data: any) {
  return api.post('/common/login/loginByEmail', data)
}
/**
 * @param {object} data 传参
 * @description 邮箱发送验证码登录接口
 * @returns {Promise} 请求结果
 */
export function reqLoginSendEmail(data: any) {
  return api.post('/common/login/sendEmail', data)
}
/**
 * @param {object} data 传参
 * @description 短信登录接口
 * @returns {Promise} 请求结果
 */
export function reqLoginSms(data: any) {
  return api.post('/common/login/loginBySms', data)
}
/**
 * @param {object} data 传参
 * @description 短信发送验证码登录接口
 * @returns {Promise} 请求结果
 */
export function reqLoginSendSms(data: any) {
  return api.post('/common/login/sendSms', data)
}
/**
 * @description 当前登录用户详情
 * @returns {Promise} 请求结果
 */
export function reqUserInfo() {
  return api.post('/common/user/detail', {})
}
/**
 * @description 注册
 * @returns {Promise} 请求结果
 */
export function reqUserRegister(data: any) {
  return api.post('/common/login/register', data)
}
/**
 * @description 重置密码
 * @returns {Promise} 请求结果
 */
export function reqUserResetPassword(data: any) {
  return api.post('/common/login/resetPassword', data)
}
/**
 * @description 注册时的选项数据
 * @returns {Promise} 请求结果
 */
export function reqUserRegisterOptions() {
  return api.post('/common/login/registerOptions', {})
}
